import { createFileRoute, Link, Outlet, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"
import { useDirectoryAdmin } from "@/hooks/use-directory-admin"
import { cn } from "@/lib/utils"

export const Route = createFileRoute("/_authed/admin")({
  component: AdminLayout,
})

function AdminLayout() {
  const { isAdmin, isLoading: isAuthLoading } = useDirectoryAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthLoading && !isAdmin) {
      navigate({ to: "/" })
    }
  }, [isAdmin, isAuthLoading, navigate])

  if (isAuthLoading || !isAdmin) return null

  return (
    <Page
      headerSlot={
        <Typography as="h1" size="2xl">
          Directory admin
        </Typography>
      }
      tabSlot={
        <nav className="flex gap-3 px-6 py-3 border-b">
          <Link
            to="/admin/listings"
            className={cn(
              "px-4 py-2 rounded-full text-sm font-medium transition",
              "bg-muted text-muted-foreground hover:bg-muted/80",
              "[&.active]:bg-primary [&.active]:text-white",
            )}
          >
            Listings
          </Link>
          <Link
            to="/admin/companies"
            className={cn(
              "px-4 py-2 rounded-full text-sm font-medium transition",
              "bg-muted text-muted-foreground hover:bg-muted/80",
              "[&.active]:bg-primary [&.active]:text-white",
            )}
          >
            Companies
          </Link>
        </nav>
      }
    >
      <Outlet />
    </Page>
  )
}
